// Removing the iframe early would abort the hand-off; a minute is plenty.
const IFRAME_LIFETIME_MS = 60_000

/**
 * Starts a download from a URL that answers with `Content-Disposition:
 * attachment`. The browser writes the response straight to disk, so even a
 * large streamed file is never held in memory here.
 *
 * A hidden iframe instead of window.location, so the page's beforeunload
 * warnings (unsaved forms) don't fire for what is only a download.
 *
 * A response the browser turns into a download never fires `load` on the
 * iframe; an error page does. That is the only failure signal available.
 */
export const startIframeDownload = (url: string, onFailed?: () => void) => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  const timer = setTimeout(() => iframe.remove(), IFRAME_LIFETIME_MS)
  iframe.addEventListener('load', () => {
    clearTimeout(timer)
    iframe.remove()
    onFailed?.()
  })
  iframe.src = url
  document.body.appendChild(iframe)
}
